import {enumType} from 'common/enumType';

const buildType = (
   id: string,
   display: string,
   name: string,
   success: boolean,
   warning: boolean,
   failure: boolean
) => ({
   id,
   display,
   name,
   success,
   warning,
   failure,
});

export const ArchiveTriggerType = enumType({
   SUCCESS: buildType('SUCCESS', 'Success', 'Success', true, false, false),
   WARNING: buildType('WARNING', 'Warning', 'Warning', false, true, false),
   FAILURE: buildType('FAILURE', 'Failure', 'Failure', false, false, true),
   SUCCESS_OR_WARNING: buildType(
      'SUCCESS_OR_WARNING',
      'SuccessWarning',
      'Success and Warning',
      true,
      true,
      false
   ),
   SUCCESS_OR_FAILURE: buildType(
      'SUCCESS_OR_FAILURE',
      'SuccessFailure',
      'Success and Failure',
      true,
      false,
      true
   ),
   WARNING_OR_FAILURE: buildType(
      'WARNING_OR_FAILURE',
      'WarningFailure',
      'Warning and Failure',
      false,
      true,
      true
   ),
   ALWAYS: buildType('ALWAYS', 'Always', 'All Jobs', true, true, true),
});
